/** The Hungarian page paths and search parameters of BREEDER v2 before 2026-10-04 and their English successors: old
 *  bookmarks and links pasted from e-mails keep working (the root route redirects them; pins, recent items and home
 *  pages stored on the server were rewritten by migration 0025, which has the same tables). */
import tables from "./legacyPaths.json";

type ParamRenames = { names?: Record<string, string>; values?: Record<string, Record<string, string>> };
// paths: old → new; params, per current page: renamed search parameters (old name → new) and renamed values (new name →
// old value → new). Migration 0025 holds the same tables (tests/unit/test_legacy_paths.py keeps them equal).
const LEGACY_PATHS: Record<string, string> = tables.paths;
const LEGACY_PARAMS: Record<string, ParamRenames> = tables.params;

/** The current href of a page link (path + search) that uses an old path or old search parameters, else undefined. */
export function currentHref(pathname: string, search: string): string | undefined {
  const old = pathname.replace(/\/+$/, "") || "/";
  const path = LEGACY_PATHS[old] ?? old;
  const renames = LEGACY_PARAMS[path];
  const query = new URLSearchParams(search);
  let changed = path !== old;
  if (renames) {
    const next = new URLSearchParams();
    for (const [key, value] of query) {
      const name = renames.names?.[key] ?? key;
      const v = renames.values?.[name]?.[value] ?? value;
      changed ||= name !== key || v !== value;
      next.append(name, v);
    }
    if (changed) return `${path}${next.size ? `?${next}` : ""}`;
  }
  return changed ? `${path}${search}` : undefined;
}
